import { render, staticRenderFns } from "./b12.vue?vue&type=template&id=d5560560&scoped=true&"
import script from "./b12.vue?vue&type=script&lang=js&"
export * from "./b12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5560560",
  null
  
)

export default component.exports